import {ref} from 'vue';

export default {
    install: (app, options) => {
        const needLoad = ref(true);
        const notificationsCount = ref(0);

        const getNotificationsCount = (parameters) => {
            const defaultParameters = {
                need_refresh: true,
            };

            parameters = Object.assign(defaultParameters, parameters)

            if (parameters.need_refresh || needLoad.value) {
                needLoad.value = false;

                axios.get('/dashboard/notifications/count')
                    .then((response) => {
                        notificationsCount.value = response.data.count;
                    });
            }
        };

        const resetAll = () => {
            needLoad.value = true;
            notificationsCount.value = 0;
        };

        app.provide('notificationsCount', notificationsCount);
        app.provide('getNotificationsCount', getNotificationsCount);

        app.provide('notificationProvider', {
            needLoad,
            getNotificationsCount,
            resetAll,
        });
    },
}
